import request from "@/utils/request";

/**
 * @desc 服务计划执行记录
 * @param data
 * @returns {AxiosPromise}
 */

// 照护服务明细
export const planRecordBeanList = (data) =>
  request({
    url: "/bizServicePlanRecord/planRecordBeanList",
    method: "POST",
    data: data,
  });

// 获取当前可见的城市公司和机构
export const getCityAndMechanism = (data) => {
  return request({
    // headers: {
    //   "Content-Type": "application/json",
    // },
    url: `/building/getListBean`,
    method: "POST",
    data,
    // baseURL: baseURL
  });
};

// 获取智慧护照人员等信息
export const getBigScreenCare = (data) => {
  return request({
    headers: {
      "Content-Type": "application/json",
    },
    url: `/bigScreen/bigScreeCare`,
    method: "POST",
    data,
  });
};

// 智慧助餐
export const wisdomBuffet = (data) => {
  return request({
    url: `/interfaces/consumptionApp.do?m=findCCRCOrderList`,
    method: "POST",
    data,
    baseURL: "cpic",
  });
};
// 获取服务分类
export const findBizServicePlanItemElementList = (data) => {
  return request({
    url: `/bizServicePlanItemElement/findBizServicePlanItemElementList`,
    method: "POST",
    data: {
      wrapper: true,
    },
  });
};
